
import Component from "vue-class-component";
import Vue from "vue";
import {
    ShipTypeLightModel, SysAdminShipTypesClient, SysAdminShipTypesSortField
} from "@/api-client";
import {BvTableCtxObject, BvTableFieldArray} from "bootstrap-vue";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import Loader from "@/features/shared/components/Loader";
import {NavigationGuardNext} from "vue-router/types/router";
import { Prop } from "vue-property-decorator";
import { debounceFn } from "debounce-decorator-ts";
import { formatDate } from "@/formatting/dateFormatter";
import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";

interface Props {
    preloadedShipTypes: ShipTypeLightModel[];
}

@Component({
    components: {
        TableEmptySlot,
        HeadingWave,
        SectionPageHeading,
    }
})

export default class ShipTypes extends Vue implements Props {
    @Prop({ required: true })
        preloadedShipTypes!: ShipTypeLightModel[];

    searchTerm = "";

    created() {
        this.getParametersFromRouteOrDefault();

        this.$watch(() => this.searchTerm, () => {
            this.reflectParametersToRoute();
        });

        this.$watch(() => this.$route.query, () => {
            this.search();
        }, { deep: true, immediate: true });
    }

    @debounceFn(100)
    reflectParametersToRoute(): void {
        this.$router.replace({
            query: {
                // Setting to 'undefined' removes parameter from URL.
                searchTerm: this.searchTerm || undefined
            }
        });
    }

    getParametersFromRouteOrDefault() {
        const route = this.$route as any;
        const query = route.query;
        this.searchTerm = query.searchTerm ? query.searchTerm : this.searchTerm;
    }

    async search() { 
        const queryResult = await new SysAdminShipTypesClient()
            .setLoader(this.loader)
            .search(
                // use placeholder values for sort, pageNumber and pageSize
                // as these dont actually get used in this particular request
                null, 1, 10,
                this.searchTerm
            )
        this.preloadedShipTypes = queryResult;
    }

    editShipType(update: ShipTypeLightModel) {
        this.$router.push({ name: 'edit-ship-type', params: { id: update.id! } });
    }

    loader = new Loader(true);

    fields: BvTableFieldArray = [
        { key: "name.estonian", label: this.$ls.Global_Label_NameEst, sortable: true, thClass: "w-25" },
        { key: "name.english", label: this.$ls.Global_Label_NameEng, sortable: true, thClass: "w-25" },
        { key: "id", label: this.$ls.Global_Label_Id, sortable: true },
        {
            key: "createdAt",
            label: this.$ls.Global_Label_CreatedAtShort,
            sortable: true,
            sortByFormatted: true,
            formatter: (value: any, key: any, item: ShipTypeLightModel): string => formatDate(item.createdAt)      
        },
        {
            key: "isActive",
            label: this.$ls.Global_Label_Active,
            sortable: true,
            sortByFormatted: true,
            formatter: (value: any, key: any, item: ShipTypeLightModel): string => translateTrueFalse(item.isActive)
        },
        {
            key: "linkIcon",
            label: "",
            sortable: false,
            tdClass:"table-actions"
        },
    ];
}
